import Container from "@client/content/Containers/container";
import appearTag from "@client/content/hocs/appear";
import { getContainerProps, getEntityRef } from "@client/content/lib/helper";
import ContentTextStyle from "@client/content/Style/Text";
import { type ContentTextComponent, type RootContainerProps } from "@client/content/types";
import { useDidUpdate } from "@client/lib/hooks";
import { type AppearOptions } from "@client/lib/jquery/appear";
import { type EntityRef } from "@client/types";
import * as React from "react";

import "./style.less";

type TitleProps = EntityRef & {
  TextComponent: ContentTextComponent;
  percent: number;
  title: string;
};

export type ProgressBarProps = RootContainerProps &
  TitleProps & {
    barStyle: React.CSSProperties;
    barContainerStyle: React.CSSProperties;
    barInnerStyle: React.CSSProperties;
    delay: string;
    titlePosition: "inside" | "up";
  };

const AppearDiv = appearTag<HTMLDivElement>("div");

const progress = (element: HTMLElement, percent: number) => {
  $(element)
    .animate(
      {
        width: `${percent}%`
      },
      "easeInOutCirc"
    )
    .addClass("progress-animated");
};

const Title = (props: TitleProps) => (
  <div className="progress-title single-line-ellipsis">
    <props.TextComponent source={props.source} id={props.id} toolbar={"basic"} prop={"title"} html={props.title} />
    <div className="divider" />
    <span className="progress-number animated fadeIn">{props.percent}</span>
    <span className="progress-type">%</span>
  </div>
);

export default (props: ProgressBarProps) => {
  const ref = React.useRef<HTMLDivElement>(null);

  const onAppear = React.useCallback(() => {
    const element = ref.current as HTMLElement;
    progress(element, props.percent);
  }, [ref, props.percent]);

  const [appearOptions, setAppearOptions] = React.useState<AppearOptions>({ onAppear, delay: props.delay });

  useDidUpdate(() => {
    const element = ref.current as HTMLElement;
    $(element).width("0%").removeClass("progress-animated");
    setAppearOptions({
      delay: props.delay,
      onAppear
    });
  }, [ref, setAppearOptions, props.delay]);

  useDidUpdate(() => {
    const element = ref.current as HTMLElement;
    progress(element, props.percent);
  }, [ref, props.percent]);

  return (
    <Container className="wsc_content_progress_bar" {...getContainerProps(props)}>
      <ContentTextStyle {...getEntityRef(props)} textSubSelector=".progress-title" />

      <div className="content">
        {props.titlePosition === "up" && (
          <Title
            source={props.source}
            id={props.id}
            title={props.title}
            percent={props.percent}
            TextComponent={props.TextComponent}
          />
        )}

        <AppearDiv className="bar-container" appearOptions={appearOptions} style={props.barContainerStyle}>
          <div ref={ref} className="progress-bar" style={props.barStyle}>
            <div style={props.barInnerStyle}>
              {props.titlePosition === "inside" && (
                <Title
                  source={props.source}
                  id={props.id}
                  title={props.title}
                  percent={props.percent}
                  TextComponent={props.TextComponent}
                />
              )}
            </div>
          </div>
        </AppearDiv>
      </div>
    </Container>
  );
};
